import { LicenseProductDetailsModel } from 'lib/ng2-sapmp/src/ui-components/licenses-card/license-product-detail.model';
import { LicenseDetailsModel } from 'lib/ng2-sapmp/src/ui-components/licenses-card/license-details.model';
import { Component, OnInit, OnDestroy, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import {
  LicensesListModel, LicensesCardModel, ProductManagementModel,
  ProductManagementFanModel, ProductManagementLicenseModel,
  ManageProductRequest
} from './shared';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { BREADCRUMBS } from 'config';
import { ManageLicensesService } from './shared';
import { UserWizardService, ValidationService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { UserProfileModel, UserWizardModel } from 'lib/ng2-sapmp/src/models';
import { FetchCriteriaModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';
import { HeaderService } from './../header/header.service';

export const ESCAPE_KEY = 27;
declare var logoutCurrentUser: any;
declare var initAriaHidden: any;
declare var removeAriaHidden: any;
declare var ENV_PORTAL: any;
const ENV_PORTAL_DOMAIN: any = (ENV_PORTAL === 'fnabc') ? 'FN' : 'ABC';

@Component({
  selector: 'app-manage-products',
  providers: [ManageLicensesService, ValidationService], // utilityService is provided in app component already
  templateUrl: './manage-licenses.component.html',
  styleUrls: ['./manage-licenses.component.scss']
})
export class ManageLicensesComponent implements OnInit, OnDestroy {

  portal: string = ENV_PORTAL;
  licenseArray: any = {};
  licensesList: LicensesListModel;
  columnCount: string;
  breadCrumbs: BreadCrumbModel[];
  singlelicense: LicenseDetailsModel;
  licenseProducts: Array<LicensesCardModel>;
  licenseProduct: LicensesCardModel;
  nextlicenseProducts: Array<LicensesCardModel>;
  nextlicenseProduct: LicensesCardModel;
  multipleUserLink: string;
  buyUnderCtn: string;
  userWizardModel: UserWizardModel;
  user: UserProfileModel;
  fanlist: Set<string>;
  rowCount: number;
  cardCount: number;
  productManagementModel: Array<ProductManagementModel>;
  productManagementFanModel: ProductManagementFanModel;
  managementFanModel: ProductManagementFanModel;
  productManagementLicenseModel: ProductManagementLicenseModel;
  fanArray: Array<string>;
  licenseMap: Map<string, Map<string, Array<ProductManagementModel>>>;
  fanMap: Map<string, Array<ProductManagementModel>>;
  manageLicenseError = '';
  companyNotFound = false;
  reviewComponentSuccessMessageFlag = false;
  reviewComponentSuccessMessage: string;
  manageProductRequest: ManageProductRequest;
  startIndex = 0;
  totalRecords = 0;
  recordsPerPage = 6;
  manageLicenseInfo = '';
  fetchCriteriaModel: FetchCriteriaModel;
  pivots: Array<MobilePivotModel>;
  licenseFlag: boolean;
  focusabbleElements: any;
  csrPermissionLicenseCardAssignButton: boolean;
  assignProductFlag: boolean;
  editNameFlag: boolean;
  licenseForm: FormGroup;
  modalClass: String;
  modalCoverClass = 'scrollcontent';
  @ViewChild('assign') assignElement;
  formErrors = {
    'productName': ''
  };

  validationMessages = {
    'productName': {
      'required': 'Enter a license group name, or click Cancel.',
      'pattern': 'Enter a valid license group name, or click Cancel.'
    }
  };
  eventEmitter: any;

  constructor(private router: Router,
    private authenticationService: AuthenticationService,
    private manageLicensesService: ManageLicensesService,
    private utilityService: UtilityService,
    private http: HttpClient, private userWizardService: UserWizardService,
    private validationService: ValidationService,
    private formBuilder: FormBuilder,
    private breadCrumbService: BreadCrumbService,
    private pageloaderService: PageLoaderService,
    private adobeAnalyticsService: AdobeAnalyticsService, private headerService: HeaderService) {
    this.reviewComponentSuccessMessageFlag = false;
    this.licenseProducts = [];
    this.multipleUserLink = 'manage.multipleuserlink';
    this.buyUnderCtn = 'manage.buyunderctn';
    this.userWizardModel = new UserWizardModel();
    this.user = new UserProfileModel();
    this.manageProductRequest = new ManageProductRequest();
    // this.manageProductRequest.brokerAccountClientIds = [];
    this.fetchCriteriaModel = new FetchCriteriaModel();
    this.pivots = new Array<MobilePivotModel>();
    this.rowCount = 0;
    this.cardCount = 0;
    this.userWizardService.removeAssignOrUnassignWizard();
    this.csrPermissionLicenseCardAssignButton = this.utilityService.checkFieldPermission('licenseCard.assign',
      JSON.parse(sessionStorage.getItem('permissions')).perm);
    this.licenseFlag = false;
  }

  ngOnInit() {
    this.headerService.setCondensedFooterStatus(false);
    this.headerService.condensedHeader('manage');
    if (this.authenticationService.getUser() === null) {
      // this.router.navigate(['login']);
      window.location.href = '/businessconsole/login';
    }
    // document.title = 'AT&T Business Console - Manage products';
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    this.pivots.push({ label: 'Console dashboard', routerLink: '/dashboard' });

    this.user = this.authenticationService.getUser();
    this.clearGlobalData();
    this.getManageLicenseData();
    this.manageLicensesService.createPageLoadProperties(this.router.routerState.snapshot.url, 'Manage');
    sessionStorage.removeItem('dataForBackInit');
    sessionStorage.removeItem('mappingFanData');
    this.buildForm();
  };

  getManageLicenseData() {
    this.fetchCriteriaModel.limit = this.recordsPerPage;
    this.fetchCriteriaModel.offset = this.startIndex;
    this.fetchCriteriaModel.sortDir = 'ASC';
    this.fetchCriteriaModel.sortField = 'serviceOfferingNameClientIdNum';
    this.manageProductRequest.fetchCriteria = this.fetchCriteriaModel;
    // commenting brokerAccountClientIds for license all page as we need to list all products under company
    // even if the fan is not in profile

    // if (!!this.user.fanList && this.user.fanList.length > 0) {
    //   this.manageProductRequest.brokerAccountClientIds = this.user.fanList;
    // } else {
    //   this.manageProductRequest.brokerAccountClientIds = [];
    // }
    this.manageProductRequest.serviceStatus = 'ACTIVE';
    let fanFlag = 0;
    this.pageloaderService.setPageLoaderStatus(false);
    this.manageLicensesService.managelicenses(this.utilityService.getEnvConfig().manageLicensesUrl, this.manageProductRequest,
      this.user.companyId)
      .subscribe(respobj => {
        if ((this.breadCrumbService.getSource() === 'managedashboard')) {
          this.breadCrumbService.setStaticBreadCrumbs('/managedashboard');
        } else if ((this.breadCrumbService.getSource() === 'manageshop')) {
          this.breadCrumbService.setStaticBreadCrumbsFromSession();
        } else {
          this.breadCrumbService.setStaticBreadCrumbs(this.router.routerState.snapshot.url);
        }
        this.breadCrumbService.setCurrentBreadCrumb({ label: 'Manage products', routerLink: '/manage' });

        this.reviewSuccess();
        this.clearGlobalData();
        this.licensesList = respobj;
        if (!!this.licensesList.dataJson) {
          this.totalRecords = this.licensesList.totalLength;
          for (const object of this.licensesList.dataJson) {
            fanFlag = 0;
            if (this.productManagementLicenseModel.licenseMap.has(object.serviceOfferingName)) {
              this.productManagementFanModel.fanMap = this.productManagementLicenseModel.licenseMap.get(object.serviceOfferingName);
              this.productManagementFanModel.fanMap.forEach((value, key) => {
                if (object.brokerAccountClientId === key) {
                  fanFlag = 1;
                  this.productManagementModel = value;
                  const card = this.buildCard(object);
                  this.productManagementModel.push(card);
                  this.productManagementFanModel.fanMap.set(key, this.productManagementModel);
                }
              });
              if (fanFlag === 0) {
                const fanMap = new Map<string, Array<ProductManagementModel>>();
                const cardArray = new Array<ProductManagementModel>();
                const card = this.buildCard(object);
                cardArray.push(card);
                this.productManagementFanModel.fanMap.set(object.brokerAccountClientId, cardArray);
              }
            } else {
              const key = object.serviceOfferingName;
              const fanMap = new Map<string, Array<ProductManagementModel>>();
              const cardArray = new Array<ProductManagementModel>();
              const card = this.buildCard(object);
              cardArray.push(card);
              fanMap.set(object.brokerAccountClientId, cardArray);
              this.productManagementLicenseModel.licenseMap.set(object.serviceOfferingName, fanMap);
            }
          }
          for (const object of this.licensesList.dataJson) {
            if (ENV_PORTAL_DOMAIN !== object.fanType) {
              this.licenseArray[object.brokerAccountClientId] = true;
            }
          }
          this.licenseMap = this.productManagementLicenseModel.licenseMap;
          this.reviewSuccess();
        } else {
          this.manageLicenseInfo = 'You don\'t have any products. Shop for products you can add';
          this.utilityService.loadFocusOnTop();
        }
        this.pageloaderService.setPageLoaderStatus(true);

      }, error => {
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
        this.pageloaderService.setPageLoaderStatus(true);
        if (error.status === 401) {
          this.manageLicenseError = 'Session Expired. Please login again';
          logoutCurrentUser(true);
        } else if (error.status === 400 && JSON.stringify(error.error[0]).indexOf('COMPANY_NOT_FOUND') !== -1) {
          this.breadCrumbService.setCurrentBreadCrumb({ label: 'Manage products', routerLink: '/manage' });
          this.companyNotFound = true;
        } else {
          this.manageLicenseError = 'Some error occurred. Please try after some time.';
        }
        this.utilityService.loadFocusOnTop();
        this.handleError(error);
      });
    // Dynamic column values settings.
  };


  handleError(error) {
    throw error;
  }

  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
  }

  clearGlobalData() {
    this.productManagementLicenseModel = new ProductManagementLicenseModel();
    this.productManagementFanModel = new ProductManagementFanModel();
    this.productManagementLicenseModel.licenseMap = new Map<string, Map<string, Array<ProductManagementModel>>>();
    this.productManagementFanModel.fanMap = new Map<string, Array<ProductManagementModel>>();
    this.licenseMap = new Map<string, Map<string, Array<ProductManagementModel>>>();
    this.fanMap = new Map<string, Array<ProductManagementModel>>();
    this.managementFanModel = new ProductManagementFanModel();
    this.productManagementModel = [];
    this.fanlist = new Set<string>();
    this.fanArray = new Array<string>();
    this.nextlicenseProducts = [];
  }

  assignUnassignWizard() {
    this.userWizardModel.previousUrl = '/manage';
    this.userWizardService.addAssignOrUnassignWizard(this.userWizardModel);
    this.router.navigate(['/manageUsers']);
  }

  buildCard(cardObject) {
    const card = new ProductManagementModel();
    card.billingClientId = cardObject.billingClientId;
    card.brokerAccountClientId = cardObject.brokerAccountClientId;
    card.clientId = cardObject.clientId;
    card.quantity = cardObject.quantity;
    card.isSingleQuantity = cardObject.isSingleQuantity;
    card.specName = cardObject.serviceOfferingName;
    card.serviceOfferCode = cardObject.serviceOfferingCode;
    card.totalLicensesInUse = cardObject.totalLicensesInUse;
    card.class = cardObject.class;
    card.fanType = cardObject.fanType;
    card.productDesc = (!!cardObject.name && cardObject.name !== null
      && cardObject.name.length > 0) ? cardObject.name : null;

    return card;
  }

  onPageChange(startIndex) {
    this.startIndex = startIndex;
    this.getManageLicenseData();
  }

  reviewSuccess() {
    if ((sessionStorage.getItem('previousRoute') === '/manageUsers/review') && (this.utilityService.getSuccessMessage() != null)) {
      this.reviewComponentSuccessMessageFlag = true;
      this.reviewComponentSuccessMessage = this.utilityService.getSuccessMessage();
      this.utilityService.loadFocusOnTop();
    } else {
      this.reviewComponentSuccessMessageFlag = false;
    }
  }

  // setting data for fan details retrive at license buy product page
  buyUnderDiffCTn(licenseMap) {
    let serviceCode: string;
    let license: any;
    const licenseVal = licenseMap.val;
    if (sessionStorage.getItem('mappingFanData') !== undefined) {
      sessionStorage.removeItem('mappingFanData');
    }
    licenseVal.forEach((entryVal: Array<ProductManagementModel>, entryKey: string) => {
      serviceCode = entryVal[0].serviceOfferCode;
    });

    license = { 'key': licenseMap.key, 'serviceOfferCode': serviceCode };
    sessionStorage.setItem('mappingFanData', JSON.stringify(license));
    this.utilityService.setSuccessMessage(null);
    this.router.navigate(['/licensesBuyProduct']);
  }

  reviewComponentSuccessMessageFlagValue(flag: boolean) {
    this.reviewComponentSuccessMessageFlag = flag;
  }

  showEditAssignModelPopUp(popupObject: any) {
    this.licenseFlag = popupObject.licenseFlag;
    this.assignProductFlag = popupObject.assignProductFlag;
    this.editNameFlag = popupObject.editNameFlag;
    this.singlelicense = popupObject.singlelicense;
    this.modalClass = 'modal-lg';
    this.eventEmitter = popupObject.formEventEmitter;
    this.loadFocustelements();
  }

  assignButton(event) {
    this.singlelicense.productDesc = this.licenseForm.get('productName').value;
    this.reviewComponentSuccessMessageFlagValue(false);
    this.cancel(event);
    this.manageLicensesService.setUpdateProduct(this.utilityService.getEnvConfig().setUpdateUrl, this.singlelicense)
      .subscribe(response => {
      }, error => {
        this.handleError(error);
      });
  }

  cancel(event) {
    this.licenseFlag = false;
    this.assignProductFlag = false;
    this.editNameFlag = false;
    document.body.classList.remove('modal-open');
    removeAriaHidden();
    this.licenseForm.reset();
    this.btnAction();
    this.reviewComponentSuccessMessageFlagValue(false);
  }

  btnAction() {
    this.focusabbleElements = undefined;
    if (this.eventEmitter.target) {
      this.eventEmitter.target.focus();
    }
  }

  loadFocustelements() {
    if (this.licenseFlag) {
      document.body.classList.add('modal-open');
      initAriaHidden();
      if (!this.focusabbleElements) {
        setTimeout(() => {
          const focusableEls = this.utilityService.getFocusableElements(this.assignElement);
          this.focusabbleElements = Array.prototype.slice.call(focusableEls);
          this.focusabbleElements[0].focus();
        });
      }
    }
  }

  buildForm() {
    this.licenseForm = this.formBuilder.group({
      productName: ['', [Validators.required, Validators.pattern(/(?!^\s+$)^.+$/)]]
    });

    this.validationService.validate(
      this.licenseForm,
      this.formErrors,
      this.validationMessages);
  }

  handleKeydown(event) {
    if (event.keyCode === ESCAPE_KEY) {
      this.btnAction();
      return;
    }
    this.utilityService.handleKeyPress(event, this.focusabbleElements);
  }

}

